import Drill from "../../model/skillTree/drill/Drill";
import GervaisAnimatedSpritesheet from "../../model/sprite/GervaisAnimatedSpritesheet";
import { GervaisSpriteNames } from "../../model/sprite/GervaisSpriteNames";
import { Settings } from "../../Settings";
import SkillRenderer from "./SkillRenderer";

export default class DrillSkillRenderer extends SkillRenderer {
    /**
     * @param {Drill[]} drillArray
     * @param {GervaisAnimatedSpritesheet} spellFxSpritesheet
     */
    constructor(drillArray, spellFxSpritesheet) {
        super();

        /**
         * @constant
         * @type {Drill[]}
         */
        this.drillArray = drillArray;

        /**
         * @constant
         * @type {GervaisAnimatedSpritesheet}
         */
        this.spellFxSpritesheet = spellFxSpritesheet;

        /**
         * The sprite animation used for the Laser skill.
         * @private
         * @type {SpriteAnimation}
         */
        this.skillAnimation = null;
        /**
         * @type {number}
         */
        this.skillStart = Date.now();
    }

    /**
     * @override
     * @param {CanvasRenderingContext2D} context 
     * @param {Projection} projection 
     */
    renderSkill(context, projection) {
        if (this.drillArray.length === 0) {
            return;
        }

        for (let i = 0; i < this.drillArray.length; i++) {
            this.renderDrill(context, projection, this.drillArray[i]);
        }
    }

    /**
     * @override
     * @param {CanvasRenderingContext2D} context 
     * @param {Projection} projection 
     * @param {Drill} drill
     */
    renderDrill(context, projection, drill) {
        // If there is no drill tile, then don't render anything.
        if (!drill.skillActive  || !drill.goalTile ) {
            return;
        }

        const now = Date.now();
        if (now - this.skillStart > 100000) {
            this.skillStart = now; // bad things happen in the sprite animation manager if the start time is from 1970.
        }

        // Make sure the sprite is initialized.
        if (!this.skillAnimation) {
            this.skillAnimation = this.spellFxSpritesheet.getSpriteAnimation(GervaisSpriteNames.EFFECT_NAME_SPARKLE_BLUE);
        }

        const startPoint = drill.startPoint;
        const endPoint = drill.endPoint;

        // Save the line width.
        const safeLineWidth = context.lineWidth;

        context.lineWidth = 5;
        context.strokeStyle = '#00F'; // maybe iterate through different colors per frame?

        context.beginPath();

        projection.worldToScreen(startPoint, this.screenCoordinate);
        context.moveTo(this.screenCoordinate.x, this.screenCoordinate.y);

        projection.worldToScreen(endPoint, this.screenCoordinate);
        context.lineTo(this.screenCoordinate.x, this.screenCoordinate.y);

        context.stroke();

        //////////////////////////////////////////

        context.lineWidth = 1;
        context.strokeStyle = '#FFF'; // maybe iterate through different colors per frame?

        context.beginPath();

        projection.worldToScreen(startPoint, this.screenCoordinate);
        context.moveTo(this.screenCoordinate.x, this.screenCoordinate.y);

        projection.worldToScreen(endPoint, this.screenCoordinate);
        context.lineTo(this.screenCoordinate.x, this.screenCoordinate.y);

        context.stroke();


        // Restore the line width
        context.lineWidth = safeLineWidth;

        if (projection.isVisible(endPoint, Settings.tile.size)) {

            this.screenCoordinate.copy(endPoint);

            // Center effect sprite on laser end point. (otherwise the top right corner is on the spot)
            this.screenCoordinate.x -= Settings.tile.halfSize;
            this.screenCoordinate.y -= Settings.tile.halfSize;

            projection.worldToScreen(this.screenCoordinate, this.screenCoordinate);

            const sprite = this.skillAnimation.getSpriteAsOf(Date.now(), this.skillStart);

            this.renderSprite(context, projection, sprite, this.screenCoordinate);
        }
    }
}